module.exports = __webpack_public_path__ + "img/TK.60aff807.png";